import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'translations/i18n';

import { ValidatedInput } from '../../validated-input';

import { kgValidationQuery } from './kg-validation-query';

const props = { label: i18n.t('weight'), maxLength: 3 };

const LABEL = i18n.t('kg');

type KgInputProps = {
    value: string;
    onChange: (e: any) => void;
    onError: (error: boolean, key: string) => void;
    lessThen?: number;
    autoFocus?: boolean;
    withEndAdornment?: boolean;
    placeholder?: string;
};

export const KgInput: FC<KgInputProps> = ({
    value,
    onChange,
    onError,
    lessThen,
    autoFocus,
    withEndAdornment = true,
    placeholder
}) => {
    const { t } = useTranslation();

    const handleError = (key: string) => (error: boolean) => onError(error, key);

    useEffect(() => () => onError(false, LABEL), []);

    const endAdornmentLabel = withEndAdornment ? LABEL : '';

    // @TODO: Write it more elegant (for eg. custom validation query);
    const validationQuery = JSON.parse(JSON.stringify(kgValidationQuery));
    if (lessThen && lessThen < validationQuery.type.lessThen.value) {
        validationQuery.type.lessThen.value = lessThen;
        validationQuery.type.lessThen.errorMessage = t('weight-input-error');
    }

    return (
        <ValidatedInput
            type="number"
            value={value}
            onChange={onChange}
            autoFocus={autoFocus}
            onError={handleError(LABEL)}
            validationQuery={validationQuery}
            endAdornment={endAdornmentLabel}
            placeholder={placeholder}
            {...props}
        />
    );
};
